import { Container } from './styled';
import { useAuth } from '../../contexts/auth';
import default_company from '../../assets/image/default_company.png'


export function Intro() {

  const { company } = useAuth()
  const companyJson = JSON.parse(company)

  return (
    <Container>
      <div>
        <img
          src={
            (companyJson?.avatar)
              ? companyJson?.avatar
              : default_company
          }
          alt="logo-company" />
      </div>
      <h1>
        {`Bem-vindo ao Web Chat do(a)`}
      </h1>
      <h1>
        {companyJson?.nome}
      </h1>
    </Container>
  );
}